
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.666 2a.667.667 0 00-1.333 0v11.333c0 .736.597 1.333 1.333 1.333H14a.667.667 0 100-1.333H2.666V2zm6.667 2A.667.667 0 008 4v6.666a.667.667 0 101.333 0V4zm-4 2c.368 0 .667.298.667.666v4a.667.667 0 11-1.334 0v-4c0-.368.299-.666.667-.666zm7.333 3.333a.667.667 0 10-1.333 0v1.333a.667.667 0 001.333 0V9.333z","fill":"#282E3E"}})])
          )
        }
      }
    